module.exports = __webpack_public_path__ + "img/80.4.NH3-N.b792bc7d.png";